function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import claimExternalWorkersService from '../../services/claim/claim_external_workers.service';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import StaffProviderModal from './StaffProviderModal';
import claimEmployeeRndApportionmentsService from '../../services/claim/claim_employee_rnd_apportionments.service';
import ApportionmentsList from '../ApportionmentsList';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import StaffProviderDropdown from './StaffProviderDropdown';
export default function ExternalWorkerRow(_ref) {
  let {
    sortedClaimProjectReports,
    index,
    claim,
    handleDelete,
    claimExternalWorkers,
    setClaimExternalWorkers,
    refreshClaim,
    headerScrollPosition,
    isShowInvolvement
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const claimEmployeeRndApportRef = useRef(null);
  const user = useSelector(state => state.auth.user);
  const claimExternalWorker = useMemo(() => {
    return _objectSpread({}, claimExternalWorkers[index]);
  }, [claimExternalWorkers, index]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (claimEmployeeRndApportRef.current) {
      claimEmployeeRndApportRef.current.scrollTo({
        left: headerScrollPosition
      });
    }
  }, [claimEmployeeRndApportRef, headerScrollPosition]);
  const updateExternalWorkers = useCallback(externalWorker => {
    const newExternalWorkers = [...claimExternalWorkers];
    newExternalWorkers[index] = _objectSpread({}, externalWorker);
    setClaimExternalWorkers([...newExternalWorkers]);
  }, [claimExternalWorkers, index, setClaimExternalWorkers]);
  const handleApportionmentChange = useErrorHandling(useCallback(async (externalWorker, apportionment) => {
    const oldApportionment = externalWorker.claim_employee_rnd_apportionments.find(a => a.claim_project_report_id === apportionment.claim_project_report_id);
    const index = externalWorker.claim_employee_rnd_apportionments.indexOf(oldApportionment);
    const newApportionments = [...externalWorker.claim_employee_rnd_apportionments];
    if (index === -1) {
      newApportionments.push(apportionment);
    } else {
      newApportionments[index] = _objectSpread({}, apportionment);
    }
    const updatedExternalWorker = await claimExternalWorkersService.get(externalWorker);
    updatedExternalWorker.claim_employee_rnd_apportionments = newApportionments;
    updateExternalWorkers(updatedExternalWorker);
  }, [updateExternalWorkers]));
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimExternalWorker[event.target.name] = value;
    updateExternalWorkers(claimExternalWorker);
  }, [updateExternalWorkers, claimExternalWorker]);
  const saveChange = useCallback(() => {
    let method;
    if (claimExternalWorker.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimExternalWorkersService[method](claimExternalWorker).then(updatedExternalWorker => {
      setHasError(false);
      updateExternalWorkers(updatedExternalWorker);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateExternalWorkers, claimExternalWorker, dispatch, refreshClaim]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  const userUnauthorizedToEdit = !hasPermissions();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "name",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "paye_ref_number",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "description_of_activity",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(StaffProviderDropdown, {
    claim: claim,
    claimExternalWorker: claimExternalWorker,
    onChange: handleChange,
    onBlur: saveChange,
    refreshClaim: refreshClaim,
    userUnauthorizedToEdit: userUnauthorizedToEdit
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "net_amount",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "capitalised_amount",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Check,
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "externally_provided_worker",
    onChange: async e => {
      await handleChange(e);
      saveChange();
    }
  })), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Check,
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "connected_party",
    onChange: async e => {
      await handleChange(e);
      saveChange();
    }
  })), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "direct_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "indirect_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions() || claim.claim_group.project_methodology !== 'employee_basis',
    name: "rnd_apportionment",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  }))), claim.claim_group.project_methodology === 'project_basis' && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ApportionmentsList, {
    claim: claim,
    sortedClaimProjectReports: sortedClaimProjectReports,
    headerScrollPosition: headerScrollPosition,
    handleApportionmentChange: handleApportionmentChange,
    claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
    model: claimExternalWorker,
    apportionmentable_type: "UkSection::ClaimExternalWorker",
    claimEmployeeRndApportRef: claimEmployeeRndApportRef,
    isShowInvolvement: isShowInvolvement
  })), !isShowInvolvement && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions() || claim.claim_group.project_methodology !== 'employee_basis',
    name: "rnd_apportionment",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    disabled: true,
    name: "allocation",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true,
    name: "rnd_amount",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true,
    name: "pnl_expenditure",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true,
    name: "s1308",
    object: _objectSpread(_objectSpread({}, claimExternalWorker), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimExternalWorker.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, hasPermissions() && /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      height: '28px'
    },
    iconClassName: "text-danger fa-2x",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    isImmutableUnderReview: true,
    onClick: handleDelete
  }))));
}